import * as React from "react";
import { forwardRef } from "react";
const SvgForward = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 48, viewBox: "0 0 16 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.00018 47.0001L14.0002 24.0001L1.00018 1.00012", stroke: "#3C4F6B", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgForward);
export { ForwardRef as ReactComponent };
